import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeCreatePopup, createPopupChangingDataClear, resetShipmentSendingToAkadError, selectCreatedShipmentID, selectShipmentCreatingStatus, selectShipmentSendingToAkadError, selectShipmentsUnauthorized, setCreatedShipmentID, setUnauthorized } from "../shipmentsSlice";
import Buttons from "./Buttons/Buttons";
// import Search from "./Search/Search";
import ShipmentsTable from "./ShipmentsTable/ShipmentsTable";
import ShipmentsUpper from "./ShipmentsUpper/ShipmentsUpper";
import { requireAuthentication } from "../../authentication/authSlice";
import { pushAlert } from "../../alerts/alertSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ShipmentsList = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch()

    const navigate = useNavigate();

    const unauthorized = useSelector(selectShipmentsUnauthorized)
    const shipmentSendingToAkadError = useSelector(selectShipmentSendingToAkadError);
    const creatingShipmentStatus = useSelector(selectShipmentCreatingStatus)
    const createdShipmentID = useSelector(selectCreatedShipmentID)
    

    useEffect(() => {
        if(unauthorized) {
            dispatch(closeCreatePopup())
            dispatch(requireAuthentication())
            dispatch(setUnauthorized(false))
        }
    }, [dispatch, unauthorized])

    useEffect(() => {
        if(shipmentSendingToAkadError) {
            dispatch(pushAlert({
                type: "danger",
                message: t(shipmentSendingToAkadError),
                delay: 3000,
            }))
            dispatch(resetShipmentSendingToAkadError())
        }
    }, [dispatch, shipmentSendingToAkadError])

    useEffect(() => {
        if(creatingShipmentStatus === "fulfilled" && createdShipmentID) {
            navigate(`/shipments/${createdShipmentID}`);
            dispatch(setCreatedShipmentID(null))
        }
    }, [createdShipmentID, creatingShipmentStatus, dispatch, navigate]);

    useEffect(() => {
        return () => {
            dispatch(createPopupChangingDataClear())
        }
    })

    return (
        <div>
            {/* Main */}
            <div className="px-2 sm:px-8 pt-5 pb-10 sm:pb-20 border shadow-2xl rounded-xl">
                <ShipmentsUpper />
                <div className='flex flex-wrap items-end justify-between gap-x-4 gap-y-2 mb-4'>
                    {/* <Search /> */}
                    <Buttons />
                </div>
                <ShipmentsTable />
            </div>
        </div>
    );
};

export default ShipmentsList;
